export default __webpack_public_path__ + "clear.27a6768a.svg";